export default __webpack_public_path__ + "static/media/Group 745.2adfb00a.svg";